import { useEffect } from "react";
import Api from "../../../../src/services/Api";
import logoPrefeitura from "../../../imagens/prefeitura_ouro_preto_logo_1.png";
import PdfAgroturism from "../../general/PdfAgritourism";
import PdfAmbiental from "../../general/PdfAmbiental";
import PdfEducation from "../../general/PdfEducation";
import PdfFabricados from "../../general/PdfFabricados";
import PdfGeneralCondiction from "../../general/PdfGeneralCondition";
import PdfHealth from "../../general/PdfHealth";
import PdfInfra from "../../general/PdfInfra";
import PdfSocial from "../../general/PdfSocial";
import PdfInitialPage from "../../general/PdfInitialPage";
import PdfNatureProduction from "../../general/PdfNatureProduction";
import PdfObra from "../../general/PdfObra";
import { AgritourismStore } from "../pages/agritourism/AgritourismStore";
import { AmbientalStore } from "../pages/ambiental/AmbientalStore";
import { EducationStore } from "../pages/education/EducationStore";
import { FabricadosStore } from "../pages/fabricados/FabricadosStore";
import { GeneralConditionStore } from "../pages/generalCondition/GeneralConditionStore";
import { HealthStore } from "../pages/health/HealthStore";
import { InfraStore } from "../pages/infra/InfraStore";
import { InitialPageStore } from "../pages/initial/InitialPageStore";
import { ObraStore } from "../pages/obra/ObraStore";
import { ProdutionStore } from "../pages/prodution/ProdutionStore";
import { SocialStore } from "../pages/social/SocialStore";
import { headerConfigMap } from "./HeaderConfig";
import styles from "./HeaderContent.module.css";

function HeaderContent({ view, distrito, menuFilterParams, filterOptions }) {
  const dropdownOptions = Api.getDistritos();
  const filterTooltip = "Filtrar";
  const filterIcon = "filtro-limpo.svg";
  const filterHoverIcon = "filtro-limpo_2.svg";
  const downloadIcon = "download.svg";
  const downloadHoverIcon = "download2.svg";
  const downloadTooltip = "Baixar relatório";

  const config = headerConfigMap[view] || {};
  const { onFilterClick, selectedOption, onSelectChange } = filterOptions;

  const prodAgropecImage = InitialPageStore((s) => s.prodAgropecImage);
  const mapImage = InitialPageStore((s) => s.mapImage);

  const imovelImage = InitialPageStore((s) => s.imovelImage);
  const areaMin = ProdutionStore((state) => state.areaMin);
  const areaMax = ProdutionStore((state) => state.areaMax);
  const prodMin = ProdutionStore((state) => state.prodMin);
  const prodMax = ProdutionStore((state) => state.prodMax);

  const naturezaImage = ProdutionStore((s) => s.naturezaImage);

  const mapImage2 = ProdutionStore((s) => s.mapImage2);

  const carroImage = GeneralConditionStore((s) => s.carroImage);
  const energiaImage = GeneralConditionStore((s) => s.energiaImage);
  const aguaImage = GeneralConditionStore((s) => s.aguaImage);

  const carro = GeneralConditionStore((s) => s.carroValue);
  const energia = GeneralConditionStore((s) => s.energiaValue);
  const agua = GeneralConditionStore((s) => s.agua);

  const captacaoAguaImage = GeneralConditionStore((s) => s.captacaoAguaImage);

  const fossaImage = GeneralConditionStore((s) => s.fossaImage);
  const lixoImage = GeneralConditionStore((s) => s.lixoImage);
  const esgotoImage = GeneralConditionStore((s) => s.esgotoImage);

  const fossa = GeneralConditionStore((s) => s.fossa);
  const lixo = GeneralConditionStore((s) => s.lixo);
  const esgoto = GeneralConditionStore((s) => s.esgoto);

  const agroMapImage = AgritourismStore((state) => state.agroMapImage);

  const agroturismo = AgritourismStore((state) => state.agroturismoValue);

  const dificuldadeAgroturismo = AgritourismStore(
    (state) => state.dificuldadeAgroturismoValue,
  );

  const interesseAgroturismo = AgritourismStore(
    (state) => state.interesseAgroturismoValue,
  );

  const formaDeRenda = AgritourismStore((state) => state.formaRendaValue);

  const agroturismoImage = AgritourismStore((state) => state.agroturismoImage);

  const dificuldadeAgroturismoImage = AgritourismStore(
    (state) => state.dificuldadeAgroturismoImage,
  );

  const interesseAgroturismoImage = AgritourismStore(
    (state) => state.interesseAgroturismoImage,
  );

  const formaDeRendaImage = AgritourismStore((state) => state.formaRendaImage);

  const healthMapImage = HealthStore((state) => state.healthMapImage);
  const frequenciaExame = HealthStore((state) => state.frequenciaExameValue);
  const atendimentoAmbulancia = HealthStore(
    (state) => state.atendimentoAmbulanciaValue,
  );
  const sistemaSaude = HealthStore((state) => state.sistemaSaudeValue);
  const usoMedicamento = HealthStore((state) => state.usoMedicamentoValue);
  const dificuldadeAtendimento = HealthStore(
    (state) => state.dificuldadeAtendimentoValue,
  );
  const possuiDoencaCronica = HealthStore(
    (state) => state.possuiDoencaCronicaValue,
  );
  const tipoDoencaCronica = HealthStore(
    (state) => state.tipoDoencaCronicaValue,
  );
  const programaSaudeRural = HealthStore(
    (state) => state.programaSaudeRuralValue,
  );

  const frequenciaExameImage = HealthStore(
    (state) => state.frequenciaExameImage,
  );
  const atendimentoAmbulanciaImage = HealthStore(
    (state) => state.atendimentoAmbulanciaImage,
  );
  const sistemaSaudeImage = HealthStore((state) => state.sistemaSaudeImage);
  const usoMedicamentoImage = HealthStore((state) => state.usoMedicamentoImage);
  const dificuldadeAtendimentoImage = HealthStore(
    (state) => state.dificuldadeAtendimentoImage,
  );
  const qualidadeSSMunicipalImage = HealthStore(
    (state) => state.qualidadeSSMunicipalImage,
  );
  const qualidadeSSRuralImage = HealthStore(
    (state) => state.qualidadeSSRuralImage,
  );
  const possuiDoencaCronicaImage = HealthStore(
    (state) => state.possuiDoencaCronicaImage,
  );
  const tipoDoencaCronicaImage = HealthStore(
    (state) => state.tipoDoencaCronicaImage,
  );
  const programaSaudeRuralImage = HealthStore(
    (state) => state.programaSaudeRuralImage,
  );

  const nivelEscolaridade = EducationStore(
    (state) => state.nivelEscolaridadeValue,
  );
  const matriculaEscola = EducationStore((state) => state.matriculaEscolaValue);
  const qualidadeEscolasRurais = EducationStore(
    (state) => state.qualidadeEscolasRuraisValue,
  );

  const educationMapImage = EducationStore((state) => state.educationMapImage);

  const nivelEscolaridadeImage = EducationStore(
    (state) => state.nivelEscolaridadeImage,
  );
  const matriculaEscolaImage = EducationStore(
    (state) => state.matriculaEscolaImage,
  );
  const qualidadeEscolasRuraisImage = EducationStore(
    (state) => state.qualidadeEscolasRuraisImage,
  );

  const fabricadosMapImage = FabricadosStore(
    (state) => state.fabricadosMapImage,
  );
  const produtosFabricadosImage = FabricadosStore(
    (state) => state.produtosFabricadosImage,
  );

  const situacaoEstradas = InfraStore((state) => state.situacaoEstradasValue);
  const manutencaoEstradas = InfraStore(
    (state) => state.manutencaoEstradasValue,
  );

  const infraMapImage = InfraStore((state) => state.infraMapImage);
  const situacaoEstradasImage = InfraStore(
    (state) => state.situacaoEstradasImage,
  );
  const manutencaoEstradasImage = InfraStore(
    (state) => state.manutencaoEstradasImage,
  );

  const infraImage = InfraStore((state) => state.infraImage);

  const gerenciaPropriedade = ObraStore(
    (state) => state.gerenciaPropriedadeValue,
  );

  const maoDeObra = ObraStore((state) => state.gerenciaPropriedadeValue);
  const organizacao = ObraStore((state) => state.gerenciaPropriedadeValue);
  const obraMapImage = ObraStore((state) => state.obraMapImage);

  const gerenciaPropriedadeImage = ObraStore(
    (state) => state.gerenciaPropriedadeImage,
  );
  const maoDeObraImage = ObraStore((state) => state.maoDeObraImage);

  const organizacaoImage = ObraStore((state) => state.organizacaoImage);

  const assistenciaTecnicaImage = ObraStore(
    (state) => state.assistenciaTecnicaImage,
  );

  const nascentes = AmbientalStore((state) => state.nascentesValue);
  const aguaCorrente = AmbientalStore((state) => state.aguaCorrenteValue);
  const mata = AmbientalStore((state) => state.mataValue);
  const agrotoxico = AmbientalStore((state) => state.agrotoxicoValue);
  const problemaSaudeAgrotoxico = AmbientalStore(
    (state) => state.problemaSaudeAgrotoxicoValue,
  );

  const ambientalMapImage = AmbientalStore((state) => state.ambientalMapImage);
  const nascentesImage = AmbientalStore((state) => state.nascentesImage);
  const aguaCorrenteImage = AmbientalStore((state) => state.aguaCorrenteImage);
  const mataImage = AmbientalStore((state) => state.mataImage);
  const agrotoxicoImage = AmbientalStore((state) => state.agrotoxicoImage);
  const problemaSaudeAgrotoxicoImage = AmbientalStore(
    (state) => state.problemaSaudeAgrotoxicoImage,
  );
  const tipoMataImage = AmbientalStore((state) => state.tipoMataImage);

  const rendaExclusiva = SocialStore((state) => state.rendaExclusivaValue);
  const creditoRural = SocialStore((state) => state.creditoRuralValue);
  const possuiEmpresa = SocialStore((state) => state.possuiEmpresaValue);
  const rendaPrincipal = SocialStore((state) => state.rendaPrincipalValue);
  const dificuldade = SocialStore((state) => state.dificuldadeValue);
  const empreendedorismo = SocialStore((state) => state.empreendedorismoValue);
  const recebeRecursos = SocialStore((state) => state.recebeRecursosValue);
  const atividadeRural = SocialStore((state) => state.atividadeRuralValue);

  const socialMapImage = SocialStore((state) => state.socialMapImage);
  const rendaExclusivaImage = SocialStore((state) => state.rendaExclusivaImage);
  const creditoRuralImage = SocialStore((state) => state.creditoRuralImage);
  const possuiEmpresaImage = SocialStore((state) => state.possuiEmpresaImage);
  const rendaPrincipalImage = SocialStore((state) => state.rendaPrincipalImage);
  const dificuldadeImage = SocialStore((state) => state.dificuldadeImage);
  const empreendedorismoImage = SocialStore(
    (state) => state.empreendedorismoImage,
  );
  const recebeRecursosImage = SocialStore((state) => state.recebeRecursosImage);
  const atividadeRuralImage = SocialStore((state) => state.atividadeRuralImage);

  const resetGeneralCondition = GeneralConditionStore((state) => state.reset);
  const resetAgritourism = AgritourismStore((state) => state.reset);
  const resetHealth = HealthStore((state) => state.reset);
  const resetEducation = EducationStore((state) => state.reset);
  const resetSocial = SocialStore((state) => state.reset);
  const resetInfra = InfraStore((state) => state.reset);
  const resetAmbiental = AmbientalStore((state) => state.reset);
  const resetObra = ObraStore((state) => state.reset);

  const { title = "Sem Título", showBack = false, showFilter = false } = config;

  const { category, subcategoria, natureza } = menuFilterParams;

  const handleDownload = () => {
    if (areaMin && areaMax && Number(areaMin) > Number(areaMax)) {
      alert("Área mínima não pode ser maior que a máxima.");
      return;
    }

    if (view === "initialPage") {
      PdfInitialPage.gerarRelatorio(
        distrito,
        natureza,
        prodAgropecImage,
        mapImage,
        imovelImage,
      );
    } else if (view === "generalCondition") {
      PdfGeneralCondiction.gerarRelatorio(
        distrito,
        category,
        subcategoria,
        natureza,
        carro,
        energia,
        agua,
        fossa,
        lixo,
        esgoto,
        carroImage,
        energiaImage,
        aguaImage,
        captacaoAguaImage,
        fossaImage,
        lixoImage,
        esgotoImage,
      );
    } else if (view === "natureProduction") {
      PdfNatureProduction.gerarRelatorio(
        distrito,
        category,
        subcategoria,
        natureza,
        areaMin,
        areaMax,
        prodMin,
        prodMax,
        naturezaImage,
        mapImage2,
      );
    } else if (view === "agritourism") {
      PdfAgroturism.gerarRelatorio(
        distrito,
        agroMapImage,
        agroturismo,
        dificuldadeAgroturismo,
        interesseAgroturismo,
        formaDeRenda,
        agroturismoImage,
        dificuldadeAgroturismoImage,
        interesseAgroturismoImage,
        formaDeRendaImage,
      );
    } else if (view === "health") {
      PdfHealth.gerarRelatorio(
        distrito,
        healthMapImage,
        frequenciaExame,
        atendimentoAmbulancia,
        sistemaSaude,
        usoMedicamento,
        dificuldadeAtendimento,
        possuiDoencaCronica,
        tipoDoencaCronica,
        programaSaudeRural,
        frequenciaExameImage,
        atendimentoAmbulanciaImage,
        sistemaSaudeImage,
        usoMedicamentoImage,
        dificuldadeAtendimentoImage,
        qualidadeSSMunicipalImage,
        qualidadeSSRuralImage,
        possuiDoencaCronicaImage,
        tipoDoencaCronicaImage,
        programaSaudeRuralImage,
      );
    } else if (view === "education") {
      PdfEducation.gerarRelatorio(
        distrito,
        educationMapImage,
        nivelEscolaridade,
        matriculaEscola,
        qualidadeEscolasRurais,
        nivelEscolaridadeImage,
        matriculaEscolaImage,
        qualidadeEscolasRuraisImage,
      );
    } else if (view === "fabricados") {
      PdfFabricados.gerarRelatorio(
        distrito,
        fabricadosMapImage,
        produtosFabricadosImage,
      );
    } else if (view === "infra") {
      PdfInfra.gerarRelatorio(
        distrito,
        situacaoEstradas,
        manutencaoEstradas,
        infraMapImage,
        situacaoEstradasImage,
        manutencaoEstradasImage,
        infraImage,
      );
    } else if (view === "obra") {
      PdfObra.gerarRelatorio(
        distrito,
        gerenciaPropriedade,
        maoDeObra,
        organizacao,
        obraMapImage,
        gerenciaPropriedadeImage,
        maoDeObraImage,
        organizacaoImage,
        assistenciaTecnicaImage,
      );
    } else if (view === "ambiental") {
      PdfAmbiental.gerarRelatorio(
        distrito,
        nascentes,
        aguaCorrente,
        mata,
        agrotoxico,
        problemaSaudeAgrotoxico,
        ambientalMapImage,
        nascentesImage,
        aguaCorrenteImage,
        mataImage,
        agrotoxicoImage,
        problemaSaudeAgrotoxicoImage,
        tipoMataImage,
      );
    } else if (view === "social") {
      PdfSocial.gerarRelatorio(
        distrito,
        rendaExclusiva,
        creditoRural,
        possuiEmpresa,
        rendaPrincipal,
        dificuldade,
        empreendedorismo,
        recebeRecursos,
        atividadeRural,
        socialMapImage,
        rendaExclusivaImage,
        creditoRuralImage,
        possuiEmpresaImage,
        rendaPrincipalImage,
        dificuldadeImage,
        empreendedorismoImage,
        recebeRecursosImage,
        atividadeRuralImage
      );
    }
  };

  // Quando muda a view, reseta a opção selecionada
  useEffect(() => {
    if (dropdownOptions.length > 0) {
      onSelectChange(dropdownOptions[0]); // Ex: "Todos"
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view]);

  // Manipulador do clique no botão de filtro
  const handleFilterClick = () => {
    resetGeneralCondition();
    resetAgritourism();
    resetHealth();
    resetEducation();
    resetSocial();
    resetInfra();
    resetAmbiental();
    resetObra();
    onSelectChange(dropdownOptions[0]); // Reseta para "Todos"
  };

  return (
    <div className={styles.headerContent}>
      <div className={styles.sectionContainer}>
        {showBack && (
          <div
            className={styles.backButton}
            onClick={() => onFilterClick("initialPage")}
            aria-label="Voltar"
          >
            &#8592;
          </div>
        )}

        <h1 className={styles.title}>{title}</h1>

        {showFilter && (
          <div className={styles.controls}>
            <select
              className={styles.dropdown}
              value={selectedOption}
              onChange={(e) => onSelectChange(e.target.value)}
            >
              {dropdownOptions.map((opt, idx) => (
                <option key={idx} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
            <button
              className={styles.pdfButton}
              style={{ backgroundImage: `url(/icones/geral/${downloadIcon})` }}
              aria-label={downloadTooltip}
              title={downloadTooltip}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundImage = `url(/icones/geral/${downloadHoverIcon})`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundImage = `url(/icones/geral/${downloadIcon})`;
              }}
              onClick={handleDownload}
            />
            <button
              className={styles.filterButton}
              onClick={handleFilterClick}
              aria-label={filterTooltip}
              title={filterTooltip}
              style={{
                backgroundImage: `url(/icones/geral/${filterIcon})`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundImage = `url(/icones/geral/${filterHoverIcon})`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundImage = `url(/icones/geral/${filterIcon})`;
              }}
            />
          </div>
        )}

        <img
          src={logoPrefeitura}
          alt="Prefeitura de Ouro Preto"
          className={styles.logo}
        />
      </div>
    </div>
  );
}

export default HeaderContent;
